import React, { useCallback } from 'react';
import ContentSection from '@/pages/Products/VpsOciDetailPage/components/ContentSection';
import useLocale from '@/hooks/useLocale';
import * as Styles from './PlanDetails.styles';
import { useSelector } from 'react-redux';
import { Button } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import { formatTimestampDate } from '@/utils/Formatters/formatTimestampDate';

const PlanDetails = ({ onGoToUpgradePlanPage }) => {
  const vpsOci = useSelector(state => state.vpsOci);
  const { details } = (vpsOci && vpsOci.data) || {};

  const {
    billing: billingLocale,
    productDetails: productDetailsLocale,
  } = useLocale();

  const {
    paymentMethods: paymentMethodsLocale,
    paymentCycle: paymentCycleLocale,
  } = billingLocale;

  const {
    vpsOci: locale,
  } = productDetailsLocale;

  const registerDateValue = (details && details.registerDate) && formatTimestampDate(details.registerDate);
  const nextDueDateValue = (details && details.nextDueDate) && formatTimestampDate(details.nextDueDate);
  const billingCycle = (details && details.billingCycle && paymentCycleLocale) && paymentCycleLocale[details.billingCycle];
  const paymentMethod = (details && details.paymentMethod && paymentMethodsLocale) && paymentMethodsLocale[details.paymentMethod];

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  const handleUpgrade = useCallback(() => {
    onGoToUpgradePlanPage && onGoToUpgradePlanPage();
  }, [onGoToUpgradePlanPage]);

  if (!details || Object.keys(details).length === 0) return null;

  return (
    <ContentSection
      direction="column"
      align="flex-start"
      justify="flex-start"
      title={locale.planDetails.title}
      testId="vpsoci-myplan-section"
    >
      <Styles.ContentWrapper>
        <Styles.DataBlocksWrapper>
          {registerDateValue && (
            <Styles.DataBlock data-testid="vpsoci-myplan-register-date-item">
              <Styles.DataLabel>{locale.planDetails.registerDate}</Styles.DataLabel>
              <Styles.DataValue data-testid="vpsoci-myplan-register-date-value">
                {registerDateValue}
              </Styles.DataValue>
            </Styles.DataBlock>
          )}
          {nextDueDateValue && (
            <Styles.DataBlock data-testid="vpsoci-myplan-next-due-date-item">
              <Styles.DataLabel>{locale.planDetails.nextDueDate}</Styles.DataLabel>
              <Styles.DataValue data-testid="vpsoci-myplan-next-due-date-value">
                {nextDueDateValue}
              </Styles.DataValue>
            </Styles.DataBlock>
          )}
          {billingCycle && (
            <Styles.DataBlock data-testid="vpsoci-myplan-billing-cycle-item">
              <Styles.DataLabel>{locale.planDetails.billingCycle}</Styles.DataLabel>
              <Styles.DataValue data-testid="vpsoci-myplan-billing-cycle-value">{billingCycle}</Styles.DataValue>
            </Styles.DataBlock>
          )}
          {paymentMethod && (
            <Styles.DataBlock data-testid="vpsoci-myplan-payment-method-item">
              <Styles.DataLabel>{locale.planDetails.paymentMethod}</Styles.DataLabel>
              <Styles.DataValue data-testid="vpsoci-myplan-payment-method-value">{paymentMethod}</Styles.DataValue>
            </Styles.DataBlock>
          )}
        </Styles.DataBlocksWrapper>
        <Styles.ButtonWrapper>
          <Button
            label={locale.planDetails.upgradeButton}
            variant="secondary"
            size="large"
            width={isMobile ? 'full' : 'fit-content'}
            onClick={handleUpgrade}
            testId="vpsoci-myplan-upgrade-button"
          />
        </Styles.ButtonWrapper>
      </Styles.ContentWrapper>
    </ContentSection>
  );
};

export default PlanDetails;
